import { ContainerModule } from '@evertel/di'
import { PasswordController } from './controllers'
const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(PasswordController).toSelf()
    })
]
export { DI_MODULES }
